import { useCallback, useEffect, useState } from 'react';
import { getAllCaseInfos } from '../services/dataService';
import type { CaseInfo } from '../types';
import useErrorHandler from './useErrorHandler';

interface UseCaseSelectionResult {
  caseInfos: CaseInfo[];
  selectedCaseId: string | null;
  setSelectedCaseId: (caseId: string | null) => void;
  loading: boolean;
  error: string | null;
  fetchCaseInfos: () => Promise<void>;
}

export const useCaseSelection = (): UseCaseSelectionResult => {
  const [caseInfos, setCaseInfos] = useState<CaseInfo[]>([]);
  const [selectedCaseId, setSelectedCaseId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const throwError = useErrorHandler();

  const fetchCaseInfos = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const infos = await getAllCaseInfos();
      setCaseInfos([...infos].reverse());
    } catch (err) {
      setError('Failed to load case list.');
      throwError(
        err instanceof Error ? err : new Error('Failed to load case list.'),
      );
    } finally {
      setLoading(false);
    }
  }, [throwError]);

  useEffect(() => {
    fetchCaseInfos();
  }, [fetchCaseInfos]);

  return {
    caseInfos,
    selectedCaseId,
    setSelectedCaseId,
    loading,
    error,
    fetchCaseInfos,
  };
};
